export const TEST_LINE_FIELDS = {
  CPC: "cpcTestLines",
  DOC: "docTestLines",
  "report-data": "reportDataTestLines",
};

export const GENERATION_FIELDS = {
  CPC: "cpcGeneralInformations",
  DOC: "docGeneralInformations",
};
